// project imports
import { withAlpha } from 'utils/colorUtils';

// ==============================|| OVERRIDES - TAB ||============================== //

export default function Tab(theme) {
  const v = theme.vars.palette;
  return {
    MuiTab: {
      styleOverrides: {
        root: {
          minHeight: 44,
          textTransform: 'none',
          fontWeight: 500,
          fontSize: '0.875rem',
          color: v.grey[600],
          padding: '10px 16px',
          '&:hover': { color: v.primary.main, backgroundColor: withAlpha(v.primary.main, 0.04) },
          '&.Mui-selected': { color: v.primary.main, fontWeight: 600 },
          '&:focus-visible': { outline: `2px solid ${withAlpha(v.primary.main, 0.5)}`, outlineOffset: -2 }
        }
      }
    }
  };
}
